import { ComponentProps } from "@ts/components";
import React, { FC } from "react";
import tw, { styled } from "twin.macro";
import AboriginalFlag from "../../../static/icons/aboriginal-flag.inline.svg";
import AccountActive from "../../../static/icons/account-active.inline.svg";
import Account from "../../../static/icons/account.inline.svg";
import AmericanExpress from "../../../static/icons/american-express.inline.svg";
import ApplePay from "../../../static/icons/apple-pay.inline.svg";
import ArrowDropDown from "../../../static/icons/arrow-dropdown.inline.svg";
import Arrow from "../../../static/icons/arrow.inline.svg";
import AtHome from "../../../static/icons/at-home.inline.svg";
import AusPost from "../../../static/icons/auspost.inline.svg";
import BagActive from "../../../static/icons/bag-active.inline.svg";
import Bag from "../../../static/icons/bag.inline.svg";
import BaredLogo from "../../../static/icons/bared-logo.inline.svg";
import Bared from "../../../static/icons/bared.inline.svg";
import Boat from "../../../static/icons/boat.inline.svg";
import BootsMen from "../../../static/icons/boots-men.inline.svg";
import BootsWomen from "../../../static/icons/boots-women.inline.svg";
import Card from "../../../static/icons/card.inline.svg";
import Chevron from "../../../static/icons/chevron.inline.svg";
import Clock from "../../../static/icons/clock.inline.svg";
import Close from "../../../static/icons/close.inline.svg";
import Copy from "../../../static/icons/copy.inline.svg";
import Cross from "../../../static/icons/cross.inline.svg";
import DarkRadioButtonEnabled from "../../../static/icons/dark-radio-enabled.inline.svg";
import DarkRadioButton from "../../../static/icons/dark-radio.inline.svg";
import Derby from "../../../static/icons/derby.inline.svg";
import Dress from "../../../static/icons/dress.inline.svg";
import Edit from "../../../static/icons/edit.inline.svg";
import Email from "../../../static/icons/email.inline.svg";
import Exclude from "../../../static/icons/exclude.inline.svg";
import Facebook from "../../../static/icons/facebook.inline.svg";
import Files from "../../../static/icons/files.inline.svg";
import FilledStar from "../../../static/icons/filled-star.inline.svg";
import FilterIcon from "../../../static/icons/filter-icon.inline.svg";
import FilterThreadActiveIcon from "../../../static/icons/filter-thread-active.inline.svg";
import FilterThreadDefaultIcon from "../../../static/icons/filter-thread-default.inline.svg";
import FitKit from "../../../static/icons/fitkit.inline.svg";
import Flats from "../../../static/icons/flats.inline.svg";
import GiftCard from "../../../static/icons/giftcard.inline.svg";
import Google from "../../../static/icons/google.inline.svg";
import GumBoots from "../../../static/icons/gum-boots.inline.svg";
import Hamburger from "../../../static/icons/hamburger-menu.inline.svg";
import Heels from "../../../static/icons/heels.inline.svg";
import Hide from "../../../static/icons/hide.inline.svg";
import HomeBootsMen from "../../../static/icons/home-boots-men.inline.svg";
import HomeBootsWomen from "../../../static/icons/home-boots-women.inline.svg";
import QuestionMark from "../../../static/icons/icon-question-mark.inline.svg";
import Success from "../../../static/icons/icon-success.inline.svg";
import Instagram from "../../../static/icons/instagram.inline.svg";
import KingletWedges from "../../../static/icons/kinglet-wedges.inline.svg";
import LiveChat from "../../../static/icons/livechat.inline.svg";
import Loafers from "../../../static/icons/loafers.inline.svg";
import Location from "../../../static/icons/location.inline.svg";
import Logout from "../../../static/icons/logout.inline.svg";
import LowHeels from "../../../static/icons/low-heels.inline.svg";
import MapPin from "../../../static/icons/map-pin.inline.svg";
import Mastercard from "../../../static/icons/mastercard.inline.svg";
import MeasuringTape from "../../../static/icons/measuring-tape.inline.svg";
import MinusSmall from "../../../static/icons/minus-small.inline.svg";
import Minus from "../../../static/icons/minus.inline.svg";
import MotmotHeels from "../../../static/icons/motmot-heels.inline.svg";
import OragnicFlower from "../../../static/icons/oragnic-flower.inline.svg";
import Paypal from "../../../static/icons/paypal.inline.svg";
import Phone from "../../../static/icons/phone.inline.svg";
import Pinterest from "../../../static/icons/pinterest.inline.svg";
import Play from "../../../static/icons/play.inline.svg";
import PlusSmall from "../../../static/icons/plus-small.inline.svg";
import Plus from "../../../static/icons/plus.inline.svg";
import RewardsStar from "../../../static/icons/rewards-star.inline.svg";
import Sandals from "../../../static/icons/sandals.inline.svg";
import SearchThin from "../../../static/icons/search-thin.inline.svg";
import Search from "../../../static/icons/search.inline.svg";
import ShikraFlats from "../../../static/icons/shikra-flats.inline.svg";
import Show from "../../../static/icons/show.inline.svg";
import SneakersMen from "../../../static/icons/sneakers-men.inline.svg";
import Sneakers from "../../../static/icons/sneakers.inline.svg";
import SpeechBubble from "../../../static/icons/speech-bubble.inline.svg";
import Spinner from "../../../static/icons/spinner.inline.svg";
import Star from "../../../static/icons/star.inline.svg";
import TickedBoxActiveReverse from "../../../static/icons/ticked-box-active-reverse.inline.svg";
import TickedBoxActive from "../../../static/icons/ticked-box-active.inline.svg";
import TickedBoxInactiveReverse from "../../../static/icons/ticked-box-inactive-reverse.inline.svg";
import TickedBoxInactive from "../../../static/icons/ticked-box-inactive.inline.svg";
import TickedRadioBoxActive from "../../../static/icons/ticked-radio-box-active.inline.svg";
import TickedRadioBoxInactive from "../../../static/icons/ticked-radio-box-inactive.inline.svg";
import TikTok from "../../../static/icons/tiktok.inline.svg";
import TitSandals from "../../../static/icons/tit-sandals.inline.svg";
import TorresStraitFlag from "../../../static/icons/torres-strait-islander-flag.inline.svg";
import VintageArrow from "../../../static/icons/vintage-arrow.inline.svg";
import Visa from "../../../static/icons/visa.inline.svg";
import Warning from "../../../static/icons/warning.inline.svg";
import Wedges from "../../../static/icons/wedges.inline.svg";
import Wishlist from "../../../static/icons/wishlist.inline.svg";
import Wishlisted from "../../../static/icons/wishlisted.inline.svg";
import Youtube from "../../../static/icons/youtube.inline.svg";
import Logo from "../../../static/logo.inline.svg";

export type IconProps = ComponentProps & {
  height?: string;
  name: keyof typeof icons;
  onClick?: () => void;
  size?: keyof typeof styles.size;
  spin?: boolean;
  width?: string;
};

const icons = {
  "map-pin": MapPin,
  aboriginalFlag: AboriginalFlag,
  account: Account,
  accountActive: AccountActive,
  americanExpress: AmericanExpress,
  applePay: ApplePay,
  arrow: Arrow,
  arrowDropdown: ArrowDropDown,
  atHome: AtHome,
  auspost: AusPost,
  bag: Bag,
  bagActive: BagActive,
  bared: Bared,
  baredLogo: BaredLogo,
  boat: Boat,
  bootsMen: BootsMen,
  bootsWomen: BootsWomen,
  card: Card,
  chevron: Chevron,
  clock: Clock,
  close: Close,
  copy: Copy,
  cross: Cross,
  darkRadioButton: DarkRadioButton,
  darkRadioButtonEnabled: DarkRadioButtonEnabled,
  derby: Derby,
  dress: Dress,
  edit: Edit,
  email: Email,
  exclude: Exclude,
  facebook: Facebook,
  files: Files,
  filledStar: FilledStar,
  filterIcon: FilterIcon,
  filterThreadDefaultIcon: FilterThreadDefaultIcon,
  filterThreadActiveIcon: FilterThreadActiveIcon,
  fitkit: FitKit,
  flats: Flats,
  giftcard: GiftCard,
  google: Google,
  gumBoots: GumBoots,
  hamburger: Hamburger,
  heels: Heels,
  hide: Hide,
  homeBootsMen: HomeBootsMen,
  homeBootswomen: HomeBootsWomen,
  instagram: Instagram,
  kingletWedges: KingletWedges,
  liveChat: LiveChat,
  loafers: Loafers,
  location: Location,
  logo: Logo,
  logout: Logout,
  lowHeels: LowHeels,
  mastercard: Mastercard,
  measuringtape: MeasuringTape,
  minus: Minus,
  minusSmall: MinusSmall,
  motmotHeels: MotmotHeels,
  oragnicFlower: OragnicFlower,
  paypal: Paypal,
  phone: Phone,
  pinterest: Pinterest,
  play: Play,
  plus: Plus,
  plusSmall: PlusSmall,
  questionmark: QuestionMark,
  rewardsStar: RewardsStar,
  sandals: Sandals,
  search: Search,
  searchThin: SearchThin,
  shikraFlats: ShikraFlats,
  show: Show,
  sneakers: Sneakers,
  sneakersMen: SneakersMen,
  speechBubble: SpeechBubble,
  spinner: Spinner,
  star: Star,
  success: Success,
  tickedBoxActive: TickedBoxActive,
  tickedBoxActiveReverse: TickedBoxActiveReverse,
  tickedBoxInactive: TickedBoxInactive,
  tickedBoxInactiveReverse: TickedBoxInactiveReverse,
  tickedRadioBoxActive: TickedRadioBoxActive,
  tickedRadioBoxInactive: TickedRadioBoxInactive,
  tiktok: TikTok,
  titSandals: TitSandals,
  torresStraitFlag: TorresStraitFlag,
  vintageArrow: VintageArrow,
  visa: Visa,
  warning: Warning,
  wedges: Wedges,
  wishlist: Wishlist,
  wishlisted: Wishlisted,
  youtube: Youtube,
};

const styles = {
  size: {
    default: tw`w-[50px] h-[50px]`,
    large: tw`w-[48px] h-[48px] md:w-[72px] md:h-[72px]`,
    logo: tw`w-auto h-[38px] md:h-[55px]`,
    medium: tw`w-[48px] h-[48px] sm:w-[60px] h-[60px]`,
    none: null,
    rect: tw`w-[144px] h-giga`,
    sm: tw`w-[40px] h-[40px]`,
    small: tw`w-[24px] w-[24px] sm:w-[32px] sm:h-[32px]`,
    xlarge: tw`w-[50px] h-[50px] sm:w-[80px] sm:h-[80px]`,
    xsmall: tw`w-[20px] h-[20px] md:w-[24px] md:h-[24px]`,
    xxlarge: tw`w-[80px] w-[80px] xl:w-[104px] xl:h-[104px]`,
    xxs: tw`w-[16px] h-[16px]`,
  },
};

const StyledIcon = styled.span`
  ${tw`select-none inline-block align-middle`}
  ${({ spin }) => (spin ? tw`animate-spin` : tw``)}
  > svg {
    ${tw`h-full`}
    ${({ size }) => (size ? styles.size[size] : styles.size.default)}
  }
`;

export const Icon: FC<IconProps> = ({
  className,
  height,
  name,
  onClick,
  width,
  size = "default",
  spin = false,
  "data-testid": dataTestId,
}: IconProps) => {
  const Component = icons[name];

  if (!Component) {
    return null;
  }

  return (
    <StyledIcon
      size={size}
      className={className}
      onClick={onClick}
      spin={spin}
      aria-hidden="true"
      data-testid={dataTestId}
    >
      <Component width={width} height={height} />
    </StyledIcon>
  );
};
